import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    invalidCoupon: 'Invalid coupon',
    label: 'Got a coupon?',
    placeholder: 'Add your coupon here',
    save: 'Save',
  },
  fr: {
    invalidCoupon: 'Ce code promo est invalide',
    label: 'Vous avez un code promo ?',
    placeholder: 'Ajouter ici votre code',
    save: 'Enregistrer',
  },
} as const);

export default locales;
